import {FC} from 'react'

import cn from 'classnames/bind'

import s from './BrainableLayout.module.scss'

const cx = cn.bind(s)

interface IBrainableLayoutProps {
	className?: string
}

const BrainableLayout: FC<IBrainableLayoutProps> = ({children, className}) => (
	<div className={cx('layout', className)}>{children}</div>
)

export default BrainableLayout
